// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__F1KMF","navbar":"Navbar_navbar__VI3uf","logo":"Navbar_logo__WjNMT","nav-links":"Navbar_nav-links__T9+KR","nav-link":"Navbar_nav-link__-oVyb"};